import { toast, type ExternalToast } from "sonner";
import type { NotificationMessage } from "./notificationCopy.ts";

type NotificationInput = NotificationMessage | string;

function resolveMessage(message: NotificationInput): NotificationMessage {
  if (typeof message === "string") {
    return { title: message };
  }
  return message;
}

function buildToast(message: NotificationInput, options?: ExternalToast) {
  const { title, description } = resolveMessage(message);
  return {
    title,
    options: {
      ...options,
      description: options?.description ?? description,
    } satisfies ExternalToast,
  };
}

export const notify = {
  message(message: NotificationInput, options?: ExternalToast) {
    const payload = buildToast(message, options);
    return toast.message(payload.title, payload.options);
  },
  success(message: NotificationInput, options?: ExternalToast) {
    const payload = buildToast(message, options);
    return toast.success(payload.title, payload.options);
  },
  info(message: NotificationInput, options?: ExternalToast) {
    const payload = buildToast(message, options);
    return toast.info(payload.title, payload.options);
  },
  warning(message: NotificationInput, options?: ExternalToast) {
    const payload = buildToast(message, options);
    return toast.warning(payload.title, payload.options);
  },
  error(message: NotificationInput, options?: ExternalToast) {
    const payload = buildToast(message, options);
    return toast.error(payload.title, payload.options);
  },
  loading(message: NotificationInput, options?: ExternalToast) {
    const payload = buildToast(message, options);
    return toast.loading(payload.title, payload.options);
  },
  dismiss: toast.dismiss,
};
